import { render, staticRenderFns } from "./FavoriteGalleryView.vue?vue&type=template&id=6e05fb6b&scoped=true"
import script from "./FavoriteGalleryView.vue?vue&type=script&lang=js"
export * from "./FavoriteGalleryView.vue?vue&type=script&lang=js"
import style0 from "./FavoriteGalleryView.vue?vue&type=style&index=0&id=6e05fb6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05fb6b",
  null
  
)

export default component.exports